export default __webpack_public_path__ + "static/media/thought-thumb.b0aeb3a9.png";